'use client'

import Link from 'next/link'
import s from './StoryComponent.module.scss'
import { useEffect, useRef, useState } from 'react'
import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion'
import FeaturedProduct from '../FeaturedProduct'

const FADE_DISTANCE = 400 // px hasta llegar a opacidad mínima

type Props = { data: any }

export default function StoryComponent({ data }: Props) {

    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const check = () => setIsMobile(window.innerWidth <= 990);
        check();
        window.addEventListener('resize', check);
        return () => window.removeEventListener('resize', check);
    }, []);

    const { scrollY } = useScroll()
  // de 1 en scroll 0 a 0.1 al llegar a FADE_DISTANCE; clamp evita valores fuera de rango
  const opacity = useTransform(scrollY, [0, isMobile ? 200 : FADE_DISTANCE], [1, 0.04], { clamp: true })

  return (
    <div className={s.product}>
        <div className={s.topSection}>
            <div className={s.author}>
                
            </div>
            <div className={s.clientYear}>
                <div className={s.client}>
                    
                </div>
                <div className={s.year}>
                    <p><time dateTime={String(data?.year)}>{data?.year}</time></p>
                </div>
            </div>
        </div>
        <div className={s.title}>
            <motion.h1 style={{ opacity, willChange: 'opacity' }}>
            {data?.title}{data.client && <span translate='no'> × {data.client.title}</span>}
            </motion.h1>
        </div>
        <div className={s.backgroundContainer}>
            <div className={s.content}>
                {(() => {
                    let firstImageModuleSeen = false
                    return data?.content?.map((module: any, index: number) => {
                        const isImageModule = ['module.centeredImages', 'module.sideImage', 'module.smallBigImage'].includes(module._type)
                        const priority = isImageModule && !firstImageModuleSeen
                        if (isImageModule) firstImageModuleSeen = true
                        switch (module._type) {
                            case 'module.centeredImages':
                                const CenteredImages = require('@/components/Modules/CenteredImages').default;
                                return <CenteredImages key={index} data={module} priority={priority} />;
                            case 'module.sideImage':
                                const SideImage = require('@/components/Modules/SideImage').default;
                                return <SideImage key={index} data={module} priority={priority} />;
                            case 'module.text':
                                const TextComponent = require('@/components/Modules/Text').default;
                                return <TextComponent key={index} data={module} />;
                            case 'module.marquee':
                                const Marquee = require('@/components/Modules/Marquee').default;
                                return <Marquee key={index} data={module} />;
                            case 'module.smallBigImage':
                                const SmallBigImages = require('@/components/Modules/SmallBigImages').default;
                                return <SmallBigImages key={index} data={module} priority={priority} />;
                            case 'module.slider':
                                const Slider = require('@/components/Modules/Slider').default;
                                return <Slider key={index} data={module} />;
                            default:
                                return null;
                        }
                    })
                })()}

            </div>
            {data?.awards && 
                <div className={s.awards}>
                    {data?.awards?.length > 0 && <h2>Awards</h2>}
                    <ul className={s.awardsList}>
                        {data?.awards?.map((award: any, i: number) => (
                            <li key={i}>
                                <p translate='no'>{award.name}</p>
                                <p><time dateTime={String(award.year)}>{award.year}</time></p>
                            </li>
                        ))}
                    </ul>
                </div>
            }
            
            {data.credits && (
                <div className={s.credits}>
                    <ul className={s.creditsList}>
                        {data.credits?.map((credit: any, i: number) => (
                            <li key={i}>
                                <p>{credit.role}</p>
                                <p translate='no'>{credit.name}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {data.related && data.related.length > 0 && (
                <div className={s.related}>
                    <h2>Related contents</h2>
                    <ul className={s.relatedList}>
                        {data.related.map((rel: any, i: number) => (
                            <li key={i}>
                                <FeaturedProduct data={rel} />
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    </div>
  )
}